var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { QueryList } from '@angular/core';
import { InfluencerGroupsService } from './influencer-groups.service';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { GroupService } from '../../services/group-details/group.service';
import { UserService } from '../../services/user.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { CommonConstant, RecentlyVisitedInfluencerGroup, InfluencerGroupStatus } from '../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { ActivePages, EventTrackerService, UserActionType, Page, TargetType, ActionSource, ActionDetails } from '../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../services/cache/cache.service';
import { InvalidAction } from '../../../models/user';
import { WebUtils } from '../../utils/web.utils';
import { AppSettings } from '../../utils/app-settings';
import { InfluencerGroup } from '../../../models/influencer-group';
import { ObjectUtils } from '../../utils/object.utils';
import { CreateGroupFragmentComponent } from './create-group-fragment/create-group-fragment.component';
import { GroupItemComponent } from './group-item/group-item.component';
import { ProjectService } from '../../services/project/project.service';
import { Project } from '../../../models/project/project';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { GroupDetailsComponent } from '../group-details/group-details.component';
import { CampaignService } from '../../services/campaign/campaign.service';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
var InfluencerGroupsComponent = /** @class */ (function (_super) {
    __extends(InfluencerGroupsComponent, _super);
    function InfluencerGroupsComponent(influencerGroupsService, referenceDataService, userService, groupService, placeholderService, modalService, eventTracker, cacheService, projectService, translate, router, campaignService, location) {
        var _this = _super.call(this, userService) || this;
        _this.influencerGroupsService = influencerGroupsService;
        _this.referenceDataService = referenceDataService;
        _this.userService = userService;
        _this.groupService = groupService;
        _this.placeholderService = placeholderService;
        _this.modalService = modalService;
        _this.eventTracker = eventTracker;
        _this.cacheService = cacheService;
        _this.projectService = projectService;
        _this.translate = translate;
        _this.router = router;
        _this.campaignService = campaignService;
        _this.location = location;
        _this.influencerGroupList = [];
        // Keep previous influencer group and used in case update failed.
        _this.previousInfluencerGroupList = [];
        _this.groupConditionTypes = [];
        // search box
        _this.searchTerm = '';
        _this.searchTermControl = new FormControl();
        _this.platformList = [];
        _this.listProjectOfAdvertiser = [];
        _this.isFetchingGroups = false;
        _this.isLoadingRecentlyVisitedInfluencerList = false;
        _this.hasNoGroup = false;
        _this.isRequestReview = false;
        _this.hasPendingInfluencer = false;
        // This is used for temporary hidden create new group fragment
        _this.temporaryHidden = false;
        _this.selectedProject = new Project();
        _this.previousSelectedProject = new Project();
        _this.countryList = [];
        // Variable use for intermediate group details page
        _this.newCreatedInfluencerGroup = new InfluencerGroup();
        _this.showIntermediateGrouDetail = false;
        _this.isHiddenBottomBar = false;
        // This is used for temporary hidden add influencer to group fragment
        _this.temporaryHiddenAddInfluencerToGroup = false;
        _this._destroyed$ = new Subject();
        return _this;
    }
    InfluencerGroupsComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.platformList = this.referenceDataService.platforms;
        this.isRequestReview = AppSettings.isRequestReview();
        this.createOrUpdateProjectSubscription = this.projectService.createOrUpdateProjectObserver.subscribe(function (project) {
            if (project) {
                _this.processingProject = project;
                _this.isShowEditProjectFragment = true;
            }
        });
        this.countryList = this.referenceDataService.countries.map(function (country) { return ({
            id: country.id,
            name: country.name
        }); });
        // debounce keystroke events
        this.searchTermCtrlSub = this.searchTermControl.valueChanges
            .debounceTime(500)
            .subscribe(function (newValue) {
            if (_this.searchingGroupSubscription) {
                _this.searchingGroupSubscription.unsubscribe();
            }
            _this.searchGroup(newValue);
        });
    };
    InfluencerGroupsComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next(true);
        _super.prototype.ngOnDestroy.call(this);
        if (this.createOrUpdateProjectSubscription) {
            this.createOrUpdateProjectSubscription.unsubscribe();
        }
        this.modalService.closeSinglePopup(this._alertRecentlyVisitedInfluencerApiFailRef);
    };
    InfluencerGroupsComponent.prototype.initInfluenceGroupList = function (companyId, reloadGroupList) {
        var _this = this;
        if (reloadGroupList) {
            this.cacheService.clear("influencer_group_list_" + companyId);
        }
        this.loadInfluencerGroup(companyId);
        this.cacheService.get(CommonConstant.NEW_AUTO_GROUP_SOURCE_KEY, this.groupService.getInfluencerGroupSourceTypes()).subscribe();
        this.cacheService.get(CommonConstant.NEW_AUTO_GROUP_FILTER_KEY, this.groupService.getInfluencerGroupFilterTypes()).subscribe();
        // load and cache the branded signup
        this.userService.getSignUpPageData(companyId).subscribe(function (res) {
            _this.cacheService.set(CommonConstant.BRANDED_SIGNUP_CONFIG_KEY + "_" + companyId, res);
        }, function (err) {
            if (err.status === 404) {
                _this.cacheService.set(CommonConstant.BRANDED_SIGNUP_CONFIG_KEY + "_" + companyId, null);
            }
        });
        this.cacheService.get("campaign_list_" + companyId, this.campaignService.getCampaignShortListForCompany(companyId)).subscribe();
        this.cacheService.get("group_list_" + companyId, this.influencerGroupsService.getInfluencerGroupShortList(companyId)).subscribe();
        this.getAllProjectOfAdvertiser(false);
    };
    InfluencerGroupsComponent.prototype.getAllProjectOfAdvertiser = function (isUpdatingAutoGroup) {
        var _this = this;
        this.cacheService.get(CommonConstant.LIST_PROJECT_KEY, this.userService.getAllProjectOfAdvertiser())
            .subscribe(function (res) {
            if (!res || !res.data) {
                _this.listProjectOfAdvertiser = [];
            }
            if (isUpdatingAutoGroup) {
                var currentProjectList_1 = _this.listProjectOfAdvertiser.map(function (p) { return p.id; });
                var selectedProject = _this.selectedProject.id > 0 ? _this.selectedProject : res.data.find(function (p) { return currentProjectList_1.indexOf(p.id) < 0; });
                var groupItem = _this.groupItemList.find(function (gi) { return gi.showGroupSetting === true; });
                if (groupItem && groupItem.newGroupSetting && selectedProject) {
                    groupItem.newGroupSetting.updateSelectedProjectForSource(selectedProject);
                }
            }
            _this.listProjectOfAdvertiser = res.data;
        });
    };
    InfluencerGroupsComponent.prototype.companyChangeCallback = function (companyId) {
        this.initInfluenceGroupList(companyId);
    };
    InfluencerGroupsComponent.prototype.loadInfluencerGroup = function (companyId, influencerGroupId) {
        var _this = this;
        console.log('load all groups');
        this.isFetchingGroups = true;
        if (!this.cacheService.has("influencer_group_list_" + companyId)) {
            this.placeholderService.show(CommonConstant.INFLUENCER_GROUP_LIST_HOLDER);
        }
        this.addRecentlyVisitedInfluencerGroup(companyId);
        this.cacheService.get("influencer_group_list_" + companyId, this.influencerGroupsService.getInfluencerGroups(companyId).pipe(takeUntil(this._destroyed$))).subscribe(function (data) {
            _this.isFetchingGroups = false;
            var groupData = [];
            if (Array.isArray(data)) {
                groupData = _this.normalizedGroupData(data);
                console.log("update UI all groups " + groupData.length);
                if (influencerGroupId) {
                    var groupNeedToUpdate = _this.influencerGroupList.findIndex(function (ig) { return ig.id === influencerGroupId; });
                    var updatedGroup = groupData.find(function (ig) { return ig.id === influencerGroupId; });
                    _this.influencerGroupList[groupNeedToUpdate].influencers = updatedGroup.influencers;
                }
                else {
                    _this.influencerGroupList = groupData;
                }
                var filteredList = _this.influencerGroupList.filter(function (item) { return item.totalPendingInfluencers > 0; });
                _this.hasPendingInfluencer = filteredList && filteredList.length > 0 ? true : false;
            }
            _this.placeholderService.hide(CommonConstant.INFLUENCER_GROUP_LIST_HOLDER);
            // Below if condition is for case creating new group.
            if (_this.previousInfluencerGroupList && _this.previousInfluencerGroupList.length > 0 && _this.influencerGroupList.length > _this.previousInfluencerGroupList.length) {
                _this.getNewCreatedGroup();
            }
        }, function (err) {
            _this.isFetchingGroups = false;
            _this._alertRecentlyVisitedInfluencerApiFailRef = _this.modalService.openInCenter(_this.alertRecentlyVisitedInfluencerApiFail, undefined);
            _this.placeholderService.hide(CommonConstant.INFLUENCER_GROUP_LIST_HOLDER);
        });
    };
    InfluencerGroupsComponent.prototype.normalizedGroupData = function (data) {
        var groups = data;
        groups.forEach(function (grp) {
            grp.totalFollowers = grp.groupKpi ? grp.groupKpi.totalFollowers : 0;
            grp.totalEngagement = grp.groupKpi ? grp.groupKpi.totalEngagement : 0;
            grp.totalImpression = grp.groupKpi ? grp.groupKpi.totalImpression : 0;
            grp.totalReach = grp.groupKpi ? grp.groupKpi.totalReach : 0;
            grp.totalPendingInfluencers = grp.totalPendingInfluencers ? grp.totalPendingInfluencers : 0;
        });
        var monthlyVisitedGroup = this.influencerGroupList.filter(function (ig) { return ig.id === 0; });
        return groups.concat.apply(groups, monthlyVisitedGroup);
    };
    InfluencerGroupsComponent.prototype.afterCreateGroup = function () {
        this.isShowCreateGroupForm = false;
        this.isShowAddInfluencerToGroup = false;
        this.initInfluenceGroupList(this.companyId, true);
    };
    InfluencerGroupsComponent.prototype.onAddInfluencerGroup = function (influencerGroup) {
        this.selectedInfluencerGroup = influencerGroup;
        this.selectedInfluencerGroup.influencer_group_id = influencerGroup.id;
        this.selectedInfluencerGroup.influencer_group_name = influencerGroup.name;
        this.isShowCreateGroupForm = false;
        this.isShowAddInfluencerToGroup = true;
        this.temporaryHidden = false;
    };
    InfluencerGroupsComponent.prototype.closeAddInfluencerToGroup = function (data) {
        if (!data.isTemporaryHidden) {
            this.temporaryHiddenAddInfluencerToGroup = false;
            this.isShowCreateGroupForm = false;
            this.isShowAddInfluencerToGroup = false;
            if (data.resetSelectedInfluencer) {
                // clear cached influencer selection
                this.selectedInfluencerToAddGroup = [];
                // clear the pending influencer to add to group
                this.pendingAddInfluencerToGroup = null;
            }
            if (data.bulkUploadInfluencers && data.bulkUploadInfluencers.length > 0) {
                this.cacheService.clear("influencer_group_list_" + this.companyId);
                this.loadInfluencerGroup(this.companyId, data.influencerGroupId);
            }
        }
        else {
            this.temporaryHiddenAddInfluencerToGroup = true;
        }
    };
    InfluencerGroupsComponent.prototype.addMoreInfluencerToCurrentGroup = function (data) {
        this.pendingAddInfluencerToGroup = data.addInfluencerGroup;
        this.selectedInfluencerToAddGroup = data.selectedInfluencers;
        this.addInfluencerToGroup(data.addInfluencerGroup);
    };
    InfluencerGroupsComponent.prototype.addInfluencerToGroup = function (influencerToAdd) {
        if (influencerToAdd.influencerList.length === 0) {
            return;
        }
        if (influencerToAdd.addForReview) {
            this.addInfluencerToGroupAsPending(influencerToAdd);
        }
        else {
            this.addInfluencerToGroupAsNormal(influencerToAdd);
        }
    };
    InfluencerGroupsComponent.prototype.addInfluencerToGroupAsNormal = function (influencerToAdd) {
        var _this = this;
        this.groupService.addInfluencerToGroup(influencerToAdd).subscribe(function (res) {
            _this.afterAddingInfluencerToGroupSuccess(influencerToAdd, false);
            _this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
        }, function (error) {
            _this.modalService.openInCenter(_this.addInfluencerToGroupErrorPopup);
        });
    };
    InfluencerGroupsComponent.prototype.addInfluencerToGroupAsPending = function (influencerToAdd) {
        var _this = this;
        this.groupService.addInfluencerToGroupAsPending(influencerToAdd).subscribe(function (res) {
            _this.afterAddingInfluencerToGroupSuccess(influencerToAdd, true);
        }, function (err) {
            _this.isShowAddInfluencerToGroup = true;
            _this.modalService.openInCenter(_this.addInfluencerToGroupErrorPopup);
        });
    };
    InfluencerGroupsComponent.prototype.afterAddingInfluencerToGroupSuccess = function (influencerToAdd, addForReview) {
        this.modalService.open(this.alertAddInfluencerToGroupSuccess, undefined, true);
        this.closeAddInfluencerToGroup({
            resetSelectedInfluencer: true
        });
        this.initInfluenceGroupList(this.companyId, true);
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
            id: influencerToAdd.influencer_group_id,
            name: influencerToAdd.influencerGroupName,
            type: TargetType.INFLUENCER_GROUP
        }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: addForReview ? ActionDetails.ADDED_INFLUENCERS_FOR_REVIEW : ActionDetails.ADDED_INFLUENCERS }, influencerToAdd), undefined, {
            type: ActivePages.GROUP_OVERVIEW,
        });
    };
    InfluencerGroupsComponent.prototype.sendInvalidActionToSegement = function (limitInfo, influencerAddToGroup) {
        var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
        // send event when adding influencer to group
        if (influencerAddToGroup) {
            this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
                id: influencerAddToGroup.influencer_group_id,
                name: influencerAddToGroup.influencerGroupName,
                type: TargetType.INFLUENCER_GROUP
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerAddToGroup), undefined, {
                type: ActivePages.GROUP_OVERVIEW,
            });
        }
    };
    InfluencerGroupsComponent.prototype.showWarningDeleteInfluencerGroupPopup = function (influencerGroup) {
        this.deleteGroupName = influencerGroup.name;
        this.selectedInfluencerGroup = influencerGroup;
        this.modalService.openInCenter(this.warningDeleteInfluencerGroupDialog);
    };
    InfluencerGroupsComponent.prototype.closeWarningDeleteInfluencerGroupPopup = function () {
        this.selectedInfluencerGroup = null;
        this.modalService.close();
    };
    InfluencerGroupsComponent.prototype.deleteInfluencerGroup = function () {
        var _this = this;
        if (this.selectedInfluencerGroup) {
            // optimis UI, close popup, remove group in UI immediately
            this.modalService.close();
            var deleteGroupIndex_1 = this.influencerGroupList.findIndex(function (ig) { return ig.id === _this.selectedInfluencerGroup.id; });
            this.influencerGroupList.splice(deleteGroupIndex_1, 1);
            this.influencerGroupsService.deleteInfluencerGroup(this.selectedInfluencerGroup.id).subscribe(function (data) {
                // build success popup data
                _this.deletePopupTitle = _this.translate.instant('notification.success');
                _this.deletePopupMsg = _this.translate.instant('group_details.influencer.delete_group_success');
                _this.modalService.open(_this.notificationDeleteGroup, _this.callbackAfterCloseDeleteGroupNotification.bind(_this), true);
                // track event to Segment
                _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
                    id: _this.selectedInfluencerGroup.id,
                    name: _this.selectedInfluencerGroup.name,
                    type: TargetType.INFLUENCER_GROUP
                }, __assign({ action: UserActionType.DELETE, source: ActionSource.PAGE }, _this.selectedInfluencerGroup), undefined, {
                    type: ActivePages.GROUP_OVERVIEW,
                });
            }, function (err) {
                // show notification when error happen
                _this.deletePopupTitle = _this.translate.instant('notification.error');
                _this.deletePopupMsg = _this.translate.instant('group_details.influencer.delete_group_error');
                _this.modalService.open(_this.notificationDeleteGroup, _this.callbackAfterCloseDeleteGroupNotification.bind(_this), true);
                // revert group in case API fail
                _this.influencerGroupList.splice(deleteGroupIndex_1, 1, _this.selectedInfluencerGroup);
            });
        }
    };
    InfluencerGroupsComponent.prototype.callbackAfterCloseDeleteGroupNotification = function () {
        this.deletePopupTitle = null;
        this.deletePopupMsg = null;
    };
    InfluencerGroupsComponent.prototype.showCreateGroupForm = function (evt) {
        var influencerGroup = new InfluencerGroup();
        if (evt) {
            influencerGroup.influencer_group_id = evt.id;
            influencerGroup.influencer_group_name = evt.name;
            influencerGroup.influencer_group_description = evt.description;
            influencerGroup.influencer_group_type = evt.type;
        }
        this.groupNeedToUpdate = evt ? influencerGroup : null;
        this.isShowCreateGroupForm = true;
        this.temporaryHidden = false;
        this.isShowAddInfluencerToGroup = false;
        this.temporaryHiddenAddInfluencerToGroup = false;
    };
    InfluencerGroupsComponent.prototype.cancelCreateOrUpdateGroup = function () {
        this.isShowCreateGroupForm = false;
        this.isShowAddInfluencerToGroup = false;
    };
    Object.defineProperty(InfluencerGroupsComponent.prototype, "isOpenBottomBar", {
        get: function () {
            return this.isShowCreateGroupForm === true || this.isShowAddInfluencerToGroup === true
                || this.isShowAddInfluencerManuallyFragment || this.isShowEditProject === true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerGroupsComponent.prototype, "isCloseBottomBar", {
        get: function () {
            return this.isShowCreateGroupForm === false && this.isShowAddInfluencerToGroup === false
                && this.isShowAddInfluencerManuallyFragment === false && !this.isShowEditProject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerGroupsComponent.prototype, "isOpenAddInfluencerManually", {
        get: function () {
            return this.isShowAddInfluencerManuallyFragment === true;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerGroupsComponent.prototype.showFragmentAddInfluencerManually = function (evt) {
        this.selectedInfluencerToAddGroup = evt.selectedInfluencers;
        this.indexInfluencerManually = evt.processingIndex;
        this.processingInfluencerSuggestion = evt.influencerSuggestion;
        this.isShowAddInfluencerManuallyFragment = true;
        this.isShowAddInfluencerToGroup = false;
        this.pendingAddInfluencerToGroup = evt.pendingAddInfluencerToGroup;
    };
    InfluencerGroupsComponent.prototype.closeFragmentAddInfluencerManually = function (influencer) {
        if (influencer) {
            this.selectedInfluencerToAddGroup.splice(this.indexInfluencerManually, 1, influencer);
        }
        this.processingInfluencerSuggestion = null;
        this.indexInfluencerManually = null;
        this.isShowAddInfluencerToGroup = true;
        this.isShowAddInfluencerManuallyFragment = false;
    };
    InfluencerGroupsComponent.prototype.closeEditProjectFragment = function () {
        this.isShowEditProjectFragment = false;
    };
    Object.defineProperty(InfluencerGroupsComponent.prototype, "showCreateGroupButton", {
        get: function () {
            return !this.isShowCreateGroupForm && !this.isShowAddInfluencerToGroup
                && !this.isShowAddInfluencerManuallyFragment && !this.isShowEditProject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerGroupsComponent.prototype, "activePage", {
        get: function () {
            return {
                type: ActivePages.GROUP_OVERVIEW
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerGroupsComponent.prototype, "invalidActionData", {
        get: function () {
            return {
                action: UserActionType.ACTION,
                item: Page.GROUP,
                target: {
                    type: TargetType.INFLUENCER_GROUP
                },
                params: {
                    action: UserActionType.CREATE,
                },
                activePage: {
                    type: ActivePages.GROUP_OVERVIEW,
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    InfluencerGroupsComponent.prototype.addRecentlyVisitedInfluencerGroup = function (companyId) {
        var _this = this;
        this.isLoadingRecentlyVisitedInfluencerList = true;
        var recentlyVisitedGroup = {
            id: 0,
            name: RecentlyVisitedInfluencerGroup.name,
            description: RecentlyVisitedInfluencerGroup.description,
            influencers: [],
            totalInfluencers: 0
        };
        var addedGroup = this.influencerGroupList.filter(function (item) { return item.name === RecentlyVisitedInfluencerGroup.name; });
        if (addedGroup.length === 0) {
            this.influencerGroupList.push(recentlyVisitedGroup);
        }
        this.groupService.getMonthlyVisitInfluencer(companyId, 8, 0)
            .pipe(takeUntil(this._destroyed$)).subscribe(function (res) {
            _this.isLoadingRecentlyVisitedInfluencerList = false;
            _this.influencerGroupList.map(function (groupItem) {
                if (groupItem.name === RecentlyVisitedInfluencerGroup.name) {
                    groupItem.influencers = res.influencers;
                    groupItem.totalInfluencers = res.total;
                }
            });
        }, function (err) {
            WebUtils.reportErrorToSentry('Failed to load Recently Viewed influencers', err);
            _this.modalService.openInCenter(_this.alertRecentlyVisitedInfluencerApiFail, undefined);
        });
    };
    InfluencerGroupsComponent.prototype.closeErrorMsgModal = function () {
        this.modalService.close();
    };
    InfluencerGroupsComponent.prototype.beforeCreateOrUpdateGroup = function (evt) {
        if (!evt) {
            return;
        }
        this.temporaryHidden = true;
        this.previousInfluencerGroupList = ObjectUtils.deepClone(this.influencerGroupList);
        if (evt && !evt.isCreated) {
            // process case update
            this.beforeUpdateGroupEvent(evt);
        }
        else {
            // process case create
            this.beforeCreateGroupEvent(evt);
        }
    };
    InfluencerGroupsComponent.prototype.beforeUpdateGroupEvent = function (evt) {
        this.influencerGroupList = this.influencerGroupList.map(function (item) {
            if (item.id === evt.influencerGroupId) {
                item.name = evt.influencerGroupName;
                item.description = evt.influencerGroupDescription;
            }
            return item;
        });
        this.groupItemList.map(function (item) {
            if (item.influencerGroup.id === evt.influencerGroupId) {
                item.isUpdatingGroupInfo = true;
            }
        });
    };
    InfluencerGroupsComponent.prototype.beforeCreateGroupEvent = function (evt) {
        this.newCreatedInfluencerGroup.influencer_group_id = CommonConstant.NEW_CREATED_GROUP_ID;
        this.newCreatedInfluencerGroup.influencer_group_name = evt.data.name;
        this.newCreatedInfluencerGroup.influencer_group_description = evt.data.description;
        this.newCreatedInfluencerGroup.status = InfluencerGroupStatus.PENDING;
        this.showIntermediateGrouDetail = true;
    };
    InfluencerGroupsComponent.prototype.afterCreateOrUpdateGroup = function (evt) {
        if (evt && !evt.isCreated) {
            this.afterUpdateGroupEvent(evt);
        }
        else {
            this.afterCreateGroupEvent(evt);
        }
    };
    InfluencerGroupsComponent.prototype.afterUpdateGroupEvent = function (evt) {
        var _this = this;
        this.groupItemList.map(function (item) {
            if (item.influencerGroup.id === evt.data.influencerGroupId) {
                item.isUpdatingGroupInfo = false;
            }
        });
        if (!evt.isError) {
            this.temporaryHidden = true;
            this.isShowCreateGroupForm = false;
            this.groupItemList.map(function (item) {
                if (item.influencerGroup.id === evt.data.influencerGroupId) {
                    // Re-assign new value to influencerGroup for create-group-fragment after updating success
                    _this.groupNeedToUpdate.influencer_group_name = evt.data.influencerGroupName;
                    _this.groupNeedToUpdate.influencer_group_description = evt.data.influencerGroupDescription;
                    // update cached data in group item
                    item.updateNewValueForCachedData(evt.data.influencerGroupId, _this.groupNeedToUpdate);
                }
            });
            this.sendUpdateGroupNameEvent(evt.data);
        }
        else {
            this.temporaryHidden = false;
            this.influencerGroupList = this.previousInfluencerGroupList;
            this.newGroupSettingErrorMsg = this.translate.instant('new_group_settings.update_group_name_error');
            this.modalService.open(this.newGroupSettingErrors, null, true);
        }
    };
    InfluencerGroupsComponent.prototype.afterCreateGroupEvent = function (evt) {
        if (!evt.isError) {
            this.temporaryHidden = true;
            this.isHiddenBottomBar = true;
            this.afterCreateGroup();
        }
        else {
            this.modalService.open(this.createNewGroupError, null, true);
            this.temporaryHidden = false;
            this.showIntermediateGrouDetail = false;
            this.isShowCreateGroupForm = true;
            this.isHiddenBottomBar = false;
        }
    };
    InfluencerGroupsComponent.prototype.sendUpdateGroupNameEvent = function (influencerGroupData) {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
            id: influencerGroupData.influencerGroupId,
            name: influencerGroupData.influencerGroupName,
            type: Page.INFLUENCER_GROUP
        }, __assign({ actionDetails: ActionDetails.UPDATED_DETAILS, source: ActionSource.ACTION_VIEW, action: UserActionType.UPDATE }, influencerGroupData), undefined, null, null);
    };
    InfluencerGroupsComponent.prototype.editOrCreateProject = function (project) {
        this.selectedProject = project;
        this.previousSelectedProject = ObjectUtils.deepClone(project);
        this.isShowEditProject = true;
    };
    InfluencerGroupsComponent.prototype.closeEditProject = function (evt) {
        if (evt.isError) {
            this.selectedProject = this.previousSelectedProject;
            this.temporaryHidden = false;
            this.newGroupSettingErrorMsg = evt.isCreated ? this.translate.instant('new_group_settings.create_project_error') : this.translate.instant('new_group_settings.update_project_error');
            this.modalService.open(this.newGroupSettingErrors, null, true);
        }
        else {
            this.isShowEditProject = false;
            this.temporaryHidden = false;
            this.selectedProject.id = evt.projectId;
            this.cacheService.clear(CommonConstant.LIST_PROJECT_KEY);
            this.getAllProjectOfAdvertiser(true);
        }
    };
    InfluencerGroupsComponent.prototype.beforeCreateOrUpdateProject = function () {
        this.temporaryHidden = true;
    };
    InfluencerGroupsComponent.prototype.searchGroup = function (term) {
        var _this = this;
        if (!term || term === '') {
            this.loadInfluencerGroup(this.companyId);
        }
        else {
            this.isFetchingGroups = true;
            console.log('clear group list');
            this.influencerGroupList = this.influencerGroupList.filter(function (ig) { return ig.id === 0; });
            this.searchingGroupSubscription = this.influencerGroupsService.searchGroupByTerm(this.companyId, term).subscribe(function (res) {
                _this.isFetchingGroups = false;
                if (Array.isArray(res)) {
                    _this.influencerGroupList = _this.normalizedGroupData(res);
                    console.log("update UI for matched groups " + _this.influencerGroupList.length);
                }
            });
        }
    };
    InfluencerGroupsComponent.prototype.closeTooltip = function (tc) {
        if (tc) {
            tc.close();
        }
    };
    InfluencerGroupsComponent.prototype.getNewCreatedGroup = function () {
        var _this = this;
        var newCreatedGroupItems = this.influencerGroupList.filter(function (listItem) { return _this.previousInfluencerGroupList.every(function (groupItem) { return groupItem.id !== listItem.id; }); });
        if (newCreatedGroupItems && newCreatedGroupItems.length > 0) {
            this.groupDetailComponent.influencerGroup.influencer_group_id = newCreatedGroupItems[0].id;
            this.groupDetailComponent.influencerGroup.status = InfluencerGroupStatus.COMPLETE;
            this.groupDetailComponent.influencerGroupId = newCreatedGroupItems[0].id;
            this.groupDetailComponent.ngOnInit();
            this.updateGroupPageUrl(newCreatedGroupItems[0]);
        }
    };
    InfluencerGroupsComponent.prototype.updateGroupPageUrl = function (newCreatedGroupItem) {
        var url = this.router.createUrlTree(['groups', newCreatedGroupItem.id], { queryParams: { activeAccount: this.userService.getCompanyId() } }).toString();
        this.location.go(url);
    };
    return InfluencerGroupsComponent;
}(AbstractAchooComponent));
export { InfluencerGroupsComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/influencer-groups.component.ts.pre-build-optimizer.js